import numeral from 'numeral'

import { DefaultProjectImage } from 'src/components/atoms/DefaultProjectImage'
import { InternalLink } from 'src/components/atoms/Link'
import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'

export interface ProjectCardRebrandProps {
  imageUrl?: string
  name: string
  location?: string
  treeCount?: number
  href?: string
  className?: string
}

const CARD_HEIGHT_CLASSES = 'h-[438px] lg:h-[544px]'

const CardBody = ({
  imageUrl,
  name,
  location,
  treeCount
}: Omit<ProjectCardRebrandProps, 'href' | 'className'>) => (
  <div className='flex flex-col gap-3'>
    <div className={`relative ${CARD_HEIGHT_CLASSES} overflow-hidden`}>
      {imageUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={imageUrl}
          alt={name}
          className='absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105'
          loading='lazy'
        />
      ) : (
        <DefaultProjectImage
          className='absolute inset-0 w-full h-full'
          alt={name}
        />
      )}
      <div className='absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-b from-transparent to-black/80 pointer-events-none' />
      {treeCount !== undefined && (
        <div className='absolute bottom-6 right-6 flex items-baseline gap-1.5 text-limeFresh whitespace-nowrap translate-y-1.5 opacity-90 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100'>
          <span className='font-body-rebrand text-[12px] leading-[1.6]'>
            Native trees received
          </span>
          <span className='font-body-rebrand text-base lg:text-[22px] font-bold leading-[1.2]'>
            {numeral(treeCount).format('0,0')}
          </span>
        </div>
      )}
    </div>
    <div className='flex flex-col gap-2'>
      <TypographyRebrand variant='h5' color='forestDeep'>
        {name}
      </TypographyRebrand>
      {location && (
        <span className='font-body-rebrand text-[12px] leading-[1.6] text-forestDeep'>
          {location}
        </span>
      )}
    </div>
  </div>
)

export const ProjectCardRebrand = ({
  imageUrl,
  name,
  location,
  treeCount,
  href,
  className = ''
}: ProjectCardRebrandProps) => {
  const body = (
    <CardBody
      imageUrl={imageUrl}
      name={name}
      location={location}
      treeCount={treeCount}
    />
  )

  if (!href) {
    return <div className={`group block ${className}`}>{body}</div>
  }

  return (
    <InternalLink
      color='black'
      href={href}
      className={`block group ${className}`}
    >
      {body}
    </InternalLink>
  )
}
